import styled from 'styled-components';

import { IconButton } from '@xingternal/button';
import { mediaSmallOrTiny } from '@xingternal/layout-tokens';
import { scale010 } from '@xingternal/tokens';

export const MeatballButton = styled(IconButton)`
  @media ${mediaSmallOrTiny} {
    border: ${scale010} solid;
    border-radius: 50%;
  }
`;
